<template>
<div class="searchform">
      <form id="form1" action="自分のサイトURL">
        <!--<input id="sbox" type="text" placeholder="キーワードを入力" v-model="keyword"/>-->
        <input id="sbox" type="text" placeholder="キーワードを入力" v-model="keyword" @keypress.enter="repoOpen" @keypress.self.prevent.enter/>
        <!--<input id="sbox" type="text" placeholder="キーワードを入力" v-model="keyword" @keydown.enter="repoOpen" @keydown.self.prevent.enter/>-->

        <button id="sbtn" type="button" @click="repoOpen">検索</button>
      </form>
 </div>
</template>
<script>
import { REPO_URL } from '@/services/config'
export default {
  name: 'RepoSearch',
  data(){
      return {
          keyword: ''
      }
  },
  methods: {
    /**
     * リポジトリ検索
     */
    repoOpen(){
      var url = `${REPO_URL}?query=${this.keyword}&submit=検索` 
      url = encodeURI(url)
      window.open(url)
    }
  }
}
</script>
